import { AlarmPriorityType } from 'src/features/alarm-rules/types';
import { SiteType, Location } from './types';
export class NewSite {
  [key: string]: any;

  id: string;

  siteName: string;

  siteType: SiteType;

  location!: Location;

  highestActiveAlarm?: AlarmPriorityType;

  status: string;

  constructor(
    id: string,
    siteName: string,
    siteType: SiteType,
    location: Location,
    status: string
  ) {
    this.id = id;
    this.siteName = siteName;
    this.siteType = siteType;
    this.location = location;
    this.status = status;
  }
}

export class Address {
  street?: string;

  city?: string;

  country?: string;

  state?: string;

  zip?: string;

  constructor(address?: Address) {
    this.street = address?.street;
    this.city = address?.city;
    this.country = address?.country;
    this.state = address?.state;
    this.zip = address?.zip;
  }

  public toString = (): string => {
    const propArray = [this.street, this.city, this.country, this.state, this.zip];
    return propArray.filter((entry) => !!entry).join(', ');
  };
}

export type SiteManagementProps = {
  data: { value: NewSite[] | null; loaded: boolean };
  dataCount: number;
  pageNum: number;
  rowsPerPage: number;
  onChangePage: (event: unknown, newPage: number) => void;
  onChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  customerId: string | null;
  skipId: string;
  search: string;
};
